<template>
  <a-modal
    title="新增分仓入库计划"
    :width="1300"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-table
      @selectedRowChange="selectedRowChange"
      :row-selection="rowSelection"
      :data-source="dataSource"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: 300 }"
      :loading="isTableLoading"
    ></a-table>
    <!-- 表格 -->
  </a-modal>
</template>

<script>
import { apiMesWarehouseEntryPlanAddList, apiMesWarehouseEntryPlanAddData } from '@/api/mes/scheduling-plan/warehouse-allocation-plan'

// 表单字段
export default {
  props: {},
  computed: {
    rowSelection() {
      return {
        onChange: this.selectedRowChange
      };
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      dataSource: [],
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '计划入库数量',
          dataIndex: 'planInboundQuantity',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '入库仓库',
          dataIndex: 'warehouseName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '计划入库日期',
          dataIndex: 'deliveryDate',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '存放区域',
          dataIndex: 'areaName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          ellipsis: true,
          align: 'center'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      isTableLoading: false
    }
  },
  created () {

  },
  methods: {
    /** 行选中 */
    getData () {
      this.isTableLoading = true
      apiMesWarehouseEntryPlanAddList().then(res => {
        if (res) {
          this.dataSource = res
        } else {
          this.dataSource = []
        }
      }).finally(() => {
        this.isTableLoading = false
      })
    },
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    show () {
      this.visible = true
      this.$nextTick(() => {
        this.getData()
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择最少一项')
        return
      }
      this.confirmLoading = true

      apiMesWarehouseEntryPlanAddData(this.selectedRows).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    inputNumberChange (record, dataIndex) {
      if (dataIndex === "assignedQty") {
        const num = (Number(record.assignedQty) + Number(record.currentAvailableQty)) / Number(record.orderQty)
        const bln = Number.isFinite(num)
        const num2 = bln ? `${this.$parseFloatToFixed(num, 2)}%` : 0
        record.assignedSatisfyRate = num2
      }
    },
    // 表单重置
    reset () {
      this.dataSource = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 170px !important;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
